export default __webpack_public_path__ + "static/media/makeitbetter.13437fa0.png";